import React, { useState, useRef } from 'react';
import { useListEditor } from '../hooks/useListEditor';

export default function TrainingQuizEditor({ quizContent, onChange }) {
  const qc = quizContent || { penalized: false, questions: [] };
  const [questionText, setQuestionText] = useState('');
  const [optionText, setOptionText] = useState('');
  const [optionCorrect, setOptionCorrect] = useState(false);
  const [tempOptions, setTempOptions] = useState([]);
  const uid = useRef(Math.random().toString(36).slice(2)).current;

  const { editIndex, select, clear, isEditing } = useListEditor(() => {
    setQuestionText('');
    setTempOptions([]);
    setOptionText('');
    setOptionCorrect(false);
  });

  const handleSelectQuestion = (i) => {
    const q = qc.questions[i];
    setQuestionText(q.question);
    setTempOptions(q.options);
    setOptionText('');
    setOptionCorrect(false);
    select(i);
  };

  const handleAddOption = () => {
    if (!optionText.trim()) return;
    setTempOptions([...tempOptions, { text: optionText.trim(), correct: optionCorrect }]);
    setOptionText('');
    setOptionCorrect(false);
  };

  const handleSaveQuestion = () => {
    if (!questionText.trim() || tempOptions.length === 0) return;
    const updated = { _id: isEditing ? qc.questions[editIndex]._id : crypto.randomUUID(), question: questionText.trim(), options: tempOptions };
    if (isEditing) {
      onChange({ ...qc, questions: qc.questions.map((q, i) => i === editIndex ? updated : q) });
    } else {
      onChange({ ...qc, questions: [...qc.questions, updated] });
    }
    clear();
  };

  const handleRemoveQuestion = (e, i) => {
    e.stopPropagation();
    onChange({ ...qc, questions: qc.questions.filter((_, idx) => idx !== i) });
    if (editIndex === i) clear();
  };

  return (
    <>
      <div className="form-group mb-3 d-flex align-items-center">
        <input type="checkbox" className="training-checkbox" id={`penalized-${uid}`}
          checked={qc.penalized}
          onChange={(e) => onChange({ ...qc, penalized: e.target.checked })} />
        <label className="training-checkbox-label" htmlFor={`penalized-${uid}`}>
          Penalizar respuestas incorrectas
        </label>
      </div>
      <div className="content-editor-add-form mb-3">
        <div className="form-group mb-2">
          <label className="form-label">Pregunta</label>
          <input type="text" className="form-control" value={questionText}
            onChange={(e) => setQuestionText(e.target.value)} placeholder="Escribe la pregunta..." />
        </div>
        <div className="d-flex gap-2 mb-2">
          <input type="text" className="form-control" value={optionText}
            onChange={(e) => setOptionText(e.target.value)} placeholder="Opción de respuesta..." />
          <div className="d-flex align-items-center gap-1 flex-shrink-0">
            <input type="checkbox" className="ml-2 training-checkbox" id={`correct-${uid}`}
              checked={optionCorrect}
              onChange={(e) => setOptionCorrect(e.target.checked)} />
            <label className=" training-checkbox-label" htmlFor={`correct-${uid}`}>Correcta</label>
          </div>
        </div>
        {tempOptions.length > 0 && (
          <ul className="blocks-list mb-2">
            {tempOptions.map((opt, i) => (
              <li key={i} className="blocks-list-item">
                <span className="blocks-list-name">{opt.text}</span>
                <span className={`blocks-list-badge ${opt.correct ? 'badge-quiz' : 'badge-text'}`}>
                  {opt.correct ? 'Correcta' : 'Incorrecta'}
                </span>
                <button type="button" className="blocks-list-remove"
                  onClick={() => setTempOptions(tempOptions.filter((_, idx) => idx !== i))}>x</button>
              </li>
            ))}
          </ul>
        )}
        <div className="d-flex flex-column align-items-start">
            <button type="button" className="btn btn-secondary mb-2" onClick={handleAddOption}>
            + Opción
          </button>
          <button type="button" className="btn btn-secondary mb-2" onClick={handleSaveQuestion}>
            {isEditing ? 'Guardar pregunta' : 'Añadir pregunta'}
          </button>
          {isEditing && (
            <button type="button" className="btn btn-outline-secondary" onClick={clear}>
              Cancelar
            </button>
          )}
        </div>
      </div>
      {qc.questions.length === 0 ? (
        <div className="blocks-list-empty">Sin preguntas aún</div>
      ) : (
        <div className="content-editor-list">
          {qc.questions.map((q, i) => (
            <div key={q._id || i} className={`content-editor-list-item ${editIndex === i ? 'selected' : ''}`}
              onClick={() => handleSelectQuestion(i)} style={{ cursor: 'pointer' }}>
              <span className="blocks-list-index">{i + 1}</span>
              <span className="blocks-list-name">{q.question}</span>
              <span className="blocks-list-score">{q.options.length} opciones</span>
              <button type="button" className="blocks-list-remove" onClick={(e) => handleRemoveQuestion(e, i)}>x</button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
